import styled from "styled-components";

const DROPDOWN_BUTTON_SIZE_X = 263;

export const StyledDropdownParent = styled.div`
    width: ${DROPDOWN_BUTTON_SIZE_X}px;
`;
